<template>
  <div>
    <el-row>
      <el-col>
        <el-table :data="tableData" size="small" border stripe highlight-current-row
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <el-table-column type="index" label="序号" align="center" width="50" min-width="30"></el-table-column>
          <el-table-column prop="afterSalesType" label="维修类型" align="center" min-width="60"></el-table-column>
          <el-table-column prop="phoneBrand" label="手机品牌" align="center" min-width="60"></el-table-column>
          <el-table-column prop="phoneModel" label="手机型号" align="center" min-width="100"></el-table-column>
          <el-table-column prop="phoneColor" label="颜色" align="center" min-width="80"></el-table-column>
          <el-table-column prop="imei" label="IMEI" align="center" min-width="100"></el-table-column>
          <el-table-column prop="orderId" label="订单号" align="center" min-width="100"></el-table-column>
          <el-table-column prop="reason" label="维修原因" align="center" min-width="160"></el-table-column>
          <el-table-column prop="phone" label="客户电话" align="center" min-width="80"></el-table-column>
          <el-table-column prop="site" label="客户地址" align="center" min-width="160"></el-table-column>
          <el-table-column fixed="right" label="操作" align="center" min-width="100px">
            <template slot-scope="scope">
            <el-button type="text" size="small" @click="maintainOutbound(scope.row)"
            style="color: #ebb563">维修后出库</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog @close="handleClose" :title="maintainOutboundFormTitle" center :visible.sync="maintainOutboundVisible"
      width="450px" :close-on-click-modal="false">
      <el-form size="small" :model="maintainOutboundForm" ref="maintainOutboundForm" :label-width="formLabelWidth">
        <el-form-item label="物流单号：" prop="outParts">
          <el-input type="textarea" v-model="maintainOutboundForm.outParts" class="form-inp-width"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleMaintainClose" type="warning" plain>取 消</el-button>
        <el-button size="small" @click="handleMaintainSubmit()" type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Socket from "@/utils/Socket";
import NMPrintSocket from "@/utils/Print";
import { outBoundPrintData } from "@/utils/printData/outBoundText";
export default {
  data() {
    const jsonObj = {
      printerImageProcessingInfo: {
        printQuantity: 1,
      },
    };
    return {
      phoneBatchPrintList: [],
      simpleList: 1,
      jsonObj,
      outBoundPrintData,
      phoneForm: {},
      props: {
        value: [String, Number],
      },
      tableData: [],
      formLabelWidth: "100px",
      maintainOutboundFormTitle: "维修后出库",
      maintainOutboundVisible: false,
      productOutboundForm: {},
      maintainOutboundForm: {},
      hasChildren: true, // 标记为有子节点
      children: [], // 实际应用中，子节点数据可能通过异步加载获取
      userId:"1940694",
    };
  },
  mounted() {
    // 创建socket实例
    const socketData = new Socket("ws://127.0.0.1:37989");

    socketData.open(
      (openBool) => {
        console.log(openBool, "openBool");
        this.printSocketOpen = openBool;
      },
      (msg) => {
        if (msg.resultAck.callback != undefined) {
          const callbackName = msg.resultAck.callback.name;
          const msgInfo = msg.resultAck.info;
          if (callbackName == "onCoverStatusChange") {
            //盒盖状态：0-闭合、1-打开
            console.log("盒盖状态", msgInfo.capStatus);
          } else if (callbackName == "onElectricityChange") {
            //"power" : 0-4, // 电池电量等级（共5档）
            console.log("电池电量等级", msgInfo.power);
          }
        }
      }
    );
    // 创建打印实例
    this.nMPrintSocket = new NMPrintSocket(socketData);
  },
  created() {
    this.afterSalesDataList();
    this.login();
  },
  methods: {
    login() {
      const currentUrl = window.location.toString();
      const urlObject = new URL(currentUrl);
      const searchParams = new URLSearchParams(urlObject.search);
      const userId = searchParams.get("qfExtUserId");
      if(userId != null || userId != undefined){
        this.userId = userId;
      }
      console.log("userid:",this.userId);
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const loginApiInstance = axios.create({
        baseURL: "/loginApi",
      });
      //使用FormData对象发送POST请求
      loginApiInstance
        .get("monkeyshop/user/login/" + this.userId)
        .then((res) => {
          // this.tableData = res.data.data;
          if (res.data.code == 200) {
          }else{
            alert(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleCancel() { },
    toIncrease() {
      console.log(this.simpleList);
      let simpleList = parseInt(this.simpleList) + 1;
      console.log(simpleList);
      this.simpleList = simpleList;
      console.log(this.simpleList);
    },

    afterSalesDataList() {
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const orderListApiInstance = axios.create({
        baseURL: "/orderListApi",
        headers: {
          "Content-Type": "application/json",
        },
      });
      let params = {
        userId: this.userId,
      }
      //使用FormData对象发送POST请求
      orderListApiInstance
        .post("monkeyshop/common/AfterSalesDataQuery",params)
        .then((res) => {
          console.log(res, "res");
          this.tableData = res.data.data.afterSalesReqList;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleClose() {
      this.productOutboundVisible = false;
      // this.$refs.productOutboundForm.resetFields();
      this.productOutboundForm = {};
      this.simpleList = 1;
    },
    handleMaintainClose() {
      this.maintainOutboundVisible = false;
      this.amaintainOutboundForm = {};
      this.simpleList = 1;
    },
    maintainOutbound(row) {
      this.maintainOutboundForm = { ...row };
      this.maintainOutboundVisible = true;
    },

    handleMaintainSubmit() {
      console.log(this.maintainOutboundForm, "this.maintainOutboundForm");
      var accessories = this.maintainOutboundForm.outParts.split('\n')
      console.log(accessories, 'accessories')
      const outParts = accessories.filter(item => item !== '');
      console.log(outParts, 'outParts')
      const outBoundApiInstance = axios.create({
        baseURL: "/orderListApi",
        "Content-Type": "application/json",
      });
      let params = {
        imei: this.maintainOutboundForm.imei,
        logisticsNo: this.maintainOutboundForm.outParts,
        userId: this.userId
      };
      //使用FormData对象发送POST请求
      console.log(params, "params");
      outBoundApiInstance
        .post("monkeyshop/common/PostRepairStockOut", params)
        .then((res) => {
          console.log(res, "res");
          this.maintainOutboundForm = {};
          this.maintainOutboundVisible = false;
          this.$message({
            message: "维修后出库成功",
            type: "success",
          });
          this.queryOrderList();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.skuList {
  border: solid 1px #ced4da;
  padding: 5px;
}

.form-inp-width {
  width: 250px;
}

.el-button--primary {
  color: #fff;
  background-color: #fb9337;
  border-color: #fb9337;
}

.el-button--primary.is-plain:focus,
.el-button--primary.is-plain:hover {
  background: #fb9337;
  border-color: #fb9337;
  color: #fff;
}

h3 {
  text-align: left;
}

h2 {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/maintainOutBound.vue